import axios from 'axios';
import i18n from 'i18next';
import tokenInterceptor from './interceptors/token';

const getLanguageHeader = () => {
  return { headers: { 'X-LOCALE': i18n.language } };
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  ...getLanguageHeader(),
});

export const getToken = () =>
  axios.get(`${process.env.REACT_APP_BASE_URL}/token`);

export const login = payload =>
  axios.post(
    `${process.env.REACT_APP_BASE_API_URL}/login-check`,
    {
      ...payload,
    },
    getLanguageHeader()
  );

export const loginConfirm = payload =>
  axios.post(
    `${process.env.REACT_APP_BASE_API_URL}/login-confirm`,
    {
      ...payload,
    },
    getLanguageHeader()
  );

export const resendMail = payload =>
  axios.post(
    `${process.env.REACT_APP_BASE_API_URL}/resend-email`,
    {
      ...payload,
    },
    getLanguageHeader()
  );

export const recoverPassword = payload =>
  axios.post(
    `${process.env.REACT_APP_BASE_API_URL}/recover-password`,
    {
      ...payload,
    },
    getLanguageHeader()
  );

export const changePassword = payload =>
  axios.post(
    `${process.env.REACT_APP_BASE_API_URL}/change-password`,
    {
      ...payload,
    },
    getLanguageHeader()
  );

export const getMediaTypes = () =>
  axios.get(`${process.env.REACT_APP_BASE_API_URL}/media`, getLanguageHeader());

tokenInterceptor(api);

export const register = payload =>
  axios.post(`${process.env.REACT_APP_BASE_API_URL}/register`, { ...payload });

export const confirmRegister = payload =>
  axios.get(`${process.env.REACT_APP_BASE_API_URL}/confirm`, { ...payload });

export const mfa = payload =>
  axios.post(`${process.env.REACT_APP_BASE_API_URL}/login-confirm`, {
    ...payload,
  });

export const checkAzureLogin = () =>
  axios.get(`${process.env.REACT_APP_AZURE_TOKEN_URL}`);

export const azureLogout = () =>
  axios.post(`${process.env.REACT_APP_AZURE_LOGOUT_URL}`);

export const getUser = () => api.get(`/me`);

export const editUser = payload => api.patch(`/me`, payload);

export const changeLogo = payload => api.post(`/logos`, payload);

export const deleteLogo = () => api.delete(`/logos`);

export const getSeasons = query => api.get(`/seasons${query}`);

export const getCompetitions = query => api.get(`/championships${query}`);

export const getClubs = query => api.get(`/teams${query}`);

export const getStadiums = query => api.get(`/venues${query}`);

export const getCarouselDates = query => api.get(`/gameweeks-dates${query}`);

export const getMatches = query => api.get(`/matches${query}`);

export const getMatch = id => api.get(`/matches/${id}`);

export const getMatchStatus = id => api.get(`/matches/${id}/status`);

export const getMatchScore = id => api.get(`/matches/${id}/score`);

export const getSquad = id => api.get(`/teams/${id}/squads`);

export const confirmRegistration = code => api.get(`/confirm/${code}`);

export const getSquadPlayer = (squadId, playerId, matchId) =>
  api.get(`teams/${squadId}/squads/${playerId}?match=${matchId}`);

export const getReferees = matchId => api.get(`matches/${matchId}/referee`);

export const getRefereeAssistants = matchId =>
  api.get(`matches/${matchId}/referees/assistants`);

export const getKits = matchId => api.get(`matches/${matchId}/kits`);

export const getGrassStatus = matchId => api.get(`matches/${matchId}/grass`);

export const getLineup = matchId => api.get(`matches/${matchId}/lineup`);

export const getActs = matchId => api.get(`matches/${matchId}/acts`);

export const getEvents = matchId => api.get(`matches/${matchId}/events`);

export const getStats = matchId => api.get(`matches/${matchId}/teamsStats`);

export const getDirectStats = matchId =>
  api.get(`matches/${matchId}/directStats`);

export const getPublicFiles = matchId => api.get(`matches/${matchId}/files`);

export const downloadFile = (documentId, isPrivate) => {
  const urlPrivate = isPrivate ? 'private/' : '';
  const url = `${urlPrivate}matches/file/${documentId}/download`;
  return api.get(url);
};

export const getPrivateFiles = matchId =>
  api.get(
    `${process.env.REACT_APP_BASE_API_URL}/private/matches/${matchId}/files`
  );

export const sendMonolog = (error, info, location) => {
  const formData = new FormData();
  formData.append(
    'stackTrace',
    new Blob(
      [
        JSON.stringify({
          name: error.name,
          description: error.message,
          stack: info,
          url: location,
        }),
      ],
      { type: 'application/json' }
    )
  );
  api.post(`${process.env.REACT_APP_BASE_URL}/error-sender-front`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default api;
